import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { Button, Form, Input, MessagePlugin, Space, Table } from 'tdesign-react';
import dayjs from 'dayjs';
import Descriptions from '@/components/Descriptions';
import useTable from '@/hooks/useTable';
import { isVoid, renderDateTime } from '@/utils/common';
import { tokenVerification } from '@/services/utilService';
import Panel from '@/components/Panel';
import Error from './Error';

const { FormItem } = Form;

export default function Token() {
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const clusterName = searchParams.get('name');
  const [validating, setValidating] = useState(false);
  const [result, setResult] = useState({});

  const columns = [
    {
      colKey: 'roleName',
      title: 'Role',
      width: 120,
    },
    {
      colKey: 'operations',
      title: '操作权限',
      width: 300,
      cell: ({ row }) => (
        <Space size={[4, 2]} breakLine>
          {row?.operations?.map((item) => (
            <Tag key={item}>{item}</Tag>
          ))}
        </Space>
      ),
    },
    {
      colKey: 'type',
      title: '资源类型',
      width: 120,
    },
    {
      colKey: 'resource',
      title: '资源',
      width: 300,
    },
    {
      colKey: 'createTime',
      title: '创建时间',
      cell: renderDateTime,
      width: 200,
    },
    {
      colKey: 'updateTime',
      title: '更新时间',
      cell: renderDateTime,
      width: 200,
    },
  ];

  const { config, setData } = useTable({
    columns,
  });

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      if (isVoid(fields.token)) {
        MessagePlugin.warning('请先输入Token');
        return;
      }
      try {
        setValidating(true);
        setData([]);
        setResult({});
        const { data } = await tokenVerification({
          token: fields.token,
          clusterName,
        });
        setResult(data);
        if (data.legal && data.permissionsInfos) {
          setData(
            data.permissionsInfos.map((item) => ({
              ...item,
              operations: item.operations.split(','),
            })),
          );
        }
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setValidating(false);
      }
    }
  };

  const getExpirText = (time) => {
    if (time < 0) {
      return '永久有效';
    }
    return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
  };

  return (
    <Root>
      <Title>Token验证</Title>
      <Panel>
        <Row>
          <Form
            labelWidth={88}
            form={form}
            style={{ flex: 1 }}
            layout='inline'
            onSubmit={handleSubmit}
          >
            <FormItem style={{ width: '100%' }} name='token' label='Token'>
              <Input placeholder='请输入Token进行校验' />
            </FormItem>
          </Form>
          <Button loading={validating} onClick={() => form.submit()}>
            校验
          </Button>
        </Row>
        {result.legal === false && <Error />}
        {result.legal === true && (
          <Container>
            <Descriptions style={{ marginBottom: 20 }} column={2}>
              <Descriptions.Item label='角色名' value={result.role} />
              <Descriptions.Item label='有效期' value={getExpirText(result.expiration)} />
            </Descriptions>
            <Table {...config} />
          </Container>
        )}
      </Panel>
    </Root>
  );
}

const Root = styled.div`
  margin-right: 20px;

  .shadow-card-body {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 200px);
  }
  label {
    font-weight: bold;
  }
`;

const Title = styled.div`
  font-weight: 600;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  color: var(--td-text-color-primary);
  line-height: 2;
  margin-bottom: 10px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;
`;

const Tag = styled.div`
  background: rgba(102, 136, 255, 0.12);
  border-radius: 6px;
  padding: 2px 10px;
  font-size: 12px;
  color: #6688ff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  padding: 20px 24px;
`;
